import styled from "styled-components";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Main = styled.main`
  padding: 180px 0 64px 0;
  min-height: calc(100vh - 110px);

  &.no-navigation {
    padding-top: 90px;
  }

  &.v2 {
    padding-top: 90px;
    padding-bottom: 0;
  }
`;
